import { call, ForkEffect, put, takeLatest } from "redux-saga/effects";
import {
  adminActions,
  getActiveOrganizationDataFailure,
  getActiveOrganizationDataSuccess,
  getCollaborativeShareUserListRequest,
  getCollaborativeShareUserListSuccess,
  getCollaborativeShareUserListFailure,
} from "./actions";
import {
  IGetActiveUserDetails,
  IOrganizationDetails,
  IUser,
  IUpdateUserDetails,
  IUserDetails,
} from "./interface";
import { AdminPennelRepository } from "@common/domain/repositories/AdminPannelRepository";
import { setUniversalStorageUnitAction } from "../formSubmission/actions";

function* setActiveOrganizationSaga() {
  try {
    const response: IOrganizationDetails = yield call(
      AdminPennelRepository.getOrganizationDetails
    );
    const userAttributes = response.userAttributes;
    yield put(setUniversalStorageUnitAction(userAttributes));
    yield put(getActiveOrganizationDataSuccess(response));
  } catch (e) {
    yield put(getActiveOrganizationDataFailure());
    console.log(e.message);
  }
}

function* fetchCollaborativeShareUserListSaga() {
  try {
    const response: IUser[] = yield call(
      AdminPennelRepository.getCollaborativeShareUserList
    );
    yield put(getCollaborativeShareUserListSuccess(response));
  } catch (e) {
    yield put(getCollaborativeShareUserListFailure());
    console.log(e.message);
  }
}

function* getActiveUserDataSaga(action: IGetActiveUserDetails) {
  const userId = action.payload.userId;
  const { onSuccess, onError } = action.payload;
  try {
    const response: IUserDetails = yield call(
      AdminPennelRepository.getUserDetails,
      userId
    );
    onSuccess(response);
  } catch (e) {
    onError(e);
  }
}

function* updateActiveUserDataSaga(action: IUpdateUserDetails) {
  const userId = action.payload.userId;
  const { onSuccess, onError } = action.payload;
  try {
    yield call(AdminPennelRepository.updateUserDetails, {
      userData: action.payload.userData,
      userId,
    });
    onSuccess();
  } catch (e) {
    onError(e);
  }
}
export function* watchAdminPanel(): Generator<ForkEffect> {
  yield takeLatest(
    adminActions.ADD_ORGANIZATION_DATA,
    setActiveOrganizationSaga
  );
  yield takeLatest( adminActions.FETCH_USER_LIST_REQUEST, fetchCollaborativeShareUserListSaga);
  yield takeLatest(adminActions.GET_ACTIVE_USER_DATA, getActiveUserDataSaga);
  yield takeLatest(adminActions.UPDATE_ACTIVE_USER_DATA, updateActiveUserDataSaga);
}
